import { useField } from 'react-final-form'

export const useChangeStep = () => {
  const { input } = useField('step')

  return (stepNum) => {
    input.onChange(stepNum)
  }
}
